import React from 'react';
import styled from "styled-components";
import Link from "next/link";
import Carousel, {CarouselItem} from '@molecules/swiper/carousel';

const VillaTypesSlider = ({urlPrefix}) => {
    const breakpoints = {
        1024: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 2.4,
        },
        320: {
            slidesPerView: 1.3,
        }
    };

    const villaTypes = [
        {title: 'جنگلی', img: 'jungle'},
        {title: 'ساحلی', img: 'beach'},
        {title: 'شهرکی', img: 'town'},
    ];

    return (
        <Carousel breakpoints={breakpoints} navigation_show={false}>
            {
                villaTypes.map((villaType, key) =>
                    <CarouselItem key={key}>
                        <Link href="/properties" as={urlPrefix + '-' + villaType.title}>
                            <a>
                                <img src={`/_img/landings/${villaType.img}.jpg`} alt={`خرید و فروش ویلای ${villaType.title} در شمال`} className="img-cover rounded-16"/>
                            </a>
                        </Link>
                    </CarouselItem>
                )
            }
        </Carousel>
    );
};

export default React.memo(VillaTypesSlider);

// styles
